(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.psInit) return;
      var track = root.querySelector('[data-ps-track]');
      var nav = root.querySelector('[data-ps-nav]');
      if (!track || !nav) return;
      root.dataset.psInit = '1';

      var prev = nav.querySelector('[data-ps-prev]');
      var next = nav.querySelector('[data-ps-next]');

      function cardStep() {
        var card = track.querySelector('.ps-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      // Move by one "page" of fully visible cards
      function pageStep() {
        var step = cardStep();
        var visible = Math.max(1, Math.floor((track.clientWidth + 1) / step));
        return step * visible;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        nav.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }

      function go(dir) {
        track.scrollBy({ left: dir * pageStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
        // scroll events are not guaranteed during programmatic smooth scroll; re-check after it settles
        setTimeout(update, 120);
        setTimeout(update, 450);
        setTimeout(update, 900);
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('scrollend', update);
      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      } else {
        window.addEventListener('resize', update);
      }
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-ps-carousel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
